var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubtraction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 119,
    height: 125.04,
    viewBox: "0 0 119 125.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Subtraction_4",
    x: 0,
    y: 0,
    width: 119,
    height: 125.04,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Subtraction_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4-2",
    "data-name": "Subtraction 4",
    d: "M24.675,34.04a3.212,3.212,0,0,1-1.407-.327L13.517,29l-8.7,4.508a3.2,3.2,0,0,1-1.486.368A3.313,3.313,0,0,1,1.009,32.9,3.463,3.463,0,0,1,0,30.427V3.722A3.664,3.664,0,0,1,3.594,0H24.406A3.664,3.664,0,0,1,28,3.722v26.87A3.392,3.392,0,0,1,24.675,34.04ZM7.373,6A1.442,1.442,0,0,0,6,7.5,1.442,1.442,0,0,0,7.373,9H20.627A1.442,1.442,0,0,0,22,7.5,1.442,1.442,0,0,0,20.627,6Z",
    transform: "translate(45.5 45.5)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtraction);
export default __webpack_public_path__ + "static/media/subtraction.db617830e09e234850ea512cbde60f2c.svg";
export { ForwardRef as ReactComponent };